export default "__VITE_ASSET__f8abc111__"